import { router } from 'expo-router';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import { Text } from '@/components/ui';

interface WebOnlyNoticeProps {
	title: string;
	body: string;
	/** Test id of the Go back button. */
	backTestID: string;
}

/**
 * What a route group renders on native in place of screens that only work on web — print pages
 * (no `window.print`), reports (too heavy for the app). Mounted by the group's `_layout`, so a
 * deep link or bookmark lands here instead of on the screen, and Go back always has somewhere
 * to go.
 */
export const WebOnlyNotice: React.FC<WebOnlyNoticeProps> = ({ title, body, backTestID }) => (
	<View style={styles.shell}>
		<Text style={styles.title}>{title}</Text>
		<Text style={styles.body}>{body}</Text>
		<Pressable
			testID={backTestID}
			onPress={() => (router.canGoBack() ? router.back() : router.replace('/'))}
			style={styles.button}
		>
			<Text style={styles.buttonText}>Go back</Text>
		</Pressable>
	</View>
);

const styles = StyleSheet.create({
	shell: { flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24, gap: 12 },
	title: { fontSize: 18, fontWeight: '700', color: '#1a2027', textAlign: 'center' },
	body: { fontSize: 14, color: '#607d8b', textAlign: 'center' },
	button: { marginTop: 8, paddingVertical: 10, paddingHorizontal: 20, borderRadius: 8, backgroundColor: '#1976d2' },
	buttonText: { color: '#fff', fontWeight: '600' },
});
